import { parseInitialLocationHash } from '../routing';

let parsedInitialLocationHash: Record<string, string> | undefined;

/**
 * Извлечь accountId из URL hash параметров.
 * Используется для Mini App авторизации.
 */
export function parseMiniAppAccountId(): string | undefined {
  if (!parsedInitialLocationHash) {
    parsedInitialLocationHash = parseInitialLocationHash();
    console.log('[parseMiniAppAccountId] Parsed hash:', parsedInitialLocationHash);
  }
  const accountId = parsedInitialLocationHash?.accountId;
  console.log('[parseMiniAppAccountId] Returning accountId:', accountId);
  return accountId;
}

/**
 * Очистить accountId из кэша после использования.
 */
export function clearMiniAppAccountId(): void {
  if (!parsedInitialLocationHash) return;
  delete parsedInitialLocationHash.accountId;
}

let isMiniAppAuthPending = false;

/**
 * Пока токен Mini App не получен от бэкенда, любой сторонний вызов `initApi`
 * (например из `switchMultitabRole` через 100 мс после старта) стартовал бы
 * обычный флоу авторизации без токена и выигрывал гонку у сетевого запроса.
 */
export function setIsMiniAppAuthPending(value: boolean): void {
  isMiniAppAuthPending = value;
}

export function getIsMiniAppAuthPending(): boolean {
  return isMiniAppAuthPending;
}

const PENDING_AUTH_STORAGE_KEY = 'tt-mini-app-pending-auth';
// Перенос длится один редирект. Всё, что пролежало дольше - хвост брошенной попытки:
// такой токен Telegram уже не примет, и лучше запросить свежий
const PENDING_AUTH_TTL_MS = 60000;

export type MiniAppPendingAuth = {
  token: string;
  dcId?: number;
  userId?: string;
};

/**
 * Токен живёт в памяти, а переезд на свободный слот аккаунта перезагружает страницу.
 * Без переноса токен терялся бы и бэкенд пришлось бы просить второй — а каждый запрос
 * это `messages.requestUrlAuth` в Telegram, то есть лишний шанс поймать FLOOD_WAIT.
 */
export function savePendingMiniAppAuth(auth: MiniAppPendingAuth): void {
  try {
    sessionStorage.setItem(PENDING_AUTH_STORAGE_KEY, JSON.stringify({ ...auth, savedAt: Date.now() }));
  } catch (err) {
    // sessionStorage может быть недоступен - тогда токен будет запрошен заново
  }
}

export function takePendingMiniAppAuth(): MiniAppPendingAuth | undefined {
  try {
    const raw = sessionStorage.getItem(PENDING_AUTH_STORAGE_KEY);
    if (!raw) return undefined;

    sessionStorage.removeItem(PENDING_AUTH_STORAGE_KEY);

    const { savedAt, ...auth } = JSON.parse(raw) as MiniAppPendingAuth & { savedAt?: number };
    if (!auth.token || !savedAt || Date.now() - savedAt > PENDING_AUTH_TTL_MS) return undefined;

    return auth;
  } catch (err) {
    return undefined;
  }
}
